import { Address } from '@31third/common';
import { BaseEntityModel } from './base-entity-model';
import { Chain } from './chain';
import { Tag } from './tag';
import { FrontendAddressUtil } from '../util';
import { TagIdentifier } from '../enum';

export class SimpleToken implements BaseEntityModel {
  public id: string | undefined;
  public creationDate: Date;
  public modificationDate: Date;
  public address: Address;
  public name: string;
  public symbol: string;
  public imageUrl: string | undefined;
  public decimals: number | undefined;
  public sliderColor: string | undefined;
  public chain: Chain | undefined;
  public tags: Tag[] | undefined;
  public deflationary: boolean | undefined;
  public automationEnabled: boolean | undefined;

  public isNative(): boolean {
    return FrontendAddressUtil.isNative(this.address, this.chain!);
  }

  public isWrappedNative(): boolean {
    return FrontendAddressUtil.equalsWrappedNative(this.address, this.chain!);
  }

  public getUnit(): number {
    if (!this.decimals) {
      return 1;
    }
    return 10 ** this.decimals;
  }

  public isStakedAAVEToken(): boolean {
    return !!this.tags?.find(tag => tag.identifier === TagIdentifier.AAVE);
  }
}
